import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import CheckOutlineIcon from '@rsuite/icons/CheckOutline'
import CloseOutlineIcon from '@rsuite/icons/CloseOutline'
import TrashIcon from '@rsuite/icons/Trash'
import axios from 'axios'
import {isEmpty} from 'lodash'
import {FiEye} from 'react-icons/fi'
import {toast} from 'react-toastify'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import SelectPicker from 'rsuite/SelectPicker'
import {StateParamsModel} from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import * as headHunt from '../redux'
import {service as headHuntService} from '../redux/service'
import ViewCandidateDetails from './ViewCandidateDetails'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

const HeadHunt = () => {
  const dispatch = useDispatch()
  const {data, loading, success, deleteSuccess, exportSuccess, applicationDetail} = useSelector(
    (state: any) => state.headHunt
  )
  const [params, setParams] = useState<StateParamsModel & {statusId?: string}>({
    page: 1,
    limit: 10,
    fromDate: '',
    toDate: '',
  })

  const [provinceData, setProvinceData] = useState([])
  const [districtData, setDistrictData] = useState([])
  const [municipalityData, setMunicipalityData] = useState([])
  const [zoneData, setZoneData] = useState([])
  const [functionalAreaData, setFunctionalAreaData] = useState([])
  const [branchData, setBranchData] = useState([])
  const [departmentData, setDepartmentData] = useState([])

  useEffect(() => {
    axios.get(API_URL + '/province').then((res) => {
      setProvinceData(res.data.data.province)
    })
    axios.get(API_URL + '/district').then((res) => {
      setDistrictData(res.data.data.district)
    })
    axios.get(API_URL + '/zone').then((res) => {
      setZoneData(res.data.data.zone)
    })
    axios.get(API_URL + '/municipality').then((res) => {
      setMunicipalityData(res.data.data.municipality)
    })
    axios.get(API_URL + '/functionalarea').then((res) => {
      setFunctionalAreaData(res.data.data.functionalArea)
    })
    axios.get(API_URL + '/branch').then((res) => {
      setBranchData(res.data.data.branch)
    })
    axios.get(API_URL + '/department').then((res) => {
      setDepartmentData(res.data.data.department)
    })
  }, [])

  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [showViewCandidateDetailsModal, setShowViewCandidatesModal] = useState(false)
  const [statusOptions, setStatusOptions] = useState<Array<{label: string; value: string}>>([])

  useEffect(() => {
    headHuntService.getHeadHuntApplicantStatuses().then((res: any) => {
      const statuses = res?.data?.data?.headHuntApplicantStatus || []
      setStatusOptions(
        statuses.map((s: any) => ({label: s.displayName, value: s.id}))
      )
    })
  }, [])

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const handleViewDetails = (id: string) => {
    dispatch(headHunt.actions.getHeadHuntApplication(id))
    setShowViewCandidatesModal(true)
  }

  const handleCloseViewDetails = () => {
    setShowViewCandidatesModal(false)
    dispatch(headHunt.actions.getHeadHuntApplicationReset())
  }

  const handleShortlist = (id: string) => {
    headHuntService
      .shortlistHeadHuntApplication(id)
      .then(() => {
        toast.success('Candidate shortlisted successfully.')
        dispatch(headHunt.actions.getHeadHuntApplications(params))
      })
      .catch((err: any) => toast.error(err?.response?.data?.message || err.message))
  }

  const handleReject = (id: string) => {
    headHuntService
      .rejectHeadHuntApplication(id)
      .then(() => {
        toast.success('Candidate rejected successfully.')
        dispatch(headHunt.actions.getHeadHuntApplications(params))
      })
      .catch((err: any) => toast.error(err?.response?.data?.message || err.message))
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    return (
      <Cell {...props} className='link-group' data-cy='head-hunt-link-group'>
        <CheckPermissions type='Edit'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='head-hunt-edit-button'
            speaker={<Tooltip>View Details</Tooltip>}
          >
            <IconButton
              onClick={() => handleViewDetails(rowData?.id)}
              data-cy='edit-button'
              appearance='subtle'
              icon={<FiEye />}
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Edit'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='head-hunt-shortlist-button'
            speaker={<Tooltip>Shortlist Candidate</Tooltip>}
          >
            <IconButton
              onClick={() => {
                if (window.confirm(`Are you sure you want to shortlist ${rowData?.name}?`)) {
                  handleShortlist(rowData?.id)
                }
              }}
              data-cy='shortlist-button'
              appearance='subtle'
              color='green'
              icon={<CheckOutlineIcon />}
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Edit'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='head-hunt-reject-button'
            speaker={<Tooltip>Reject Candidate</Tooltip>}
          >
            <IconButton
              onClick={() => {
                if (window.confirm(`Are you sure you want to reject ${rowData?.name}?`)) {
                  handleReject(rowData?.id)
                }
              }}
              data-cy='reject-button'
              appearance='subtle'
              color='orange'
              icon={<CloseOutlineIcon />}
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='head-hunt-delete-button'
            speaker={<Tooltip>Delete</Tooltip>}
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let atmId = [rowData.id]
                setCheckedValues(atmId)
              }}
              data-cy='delete-button'
              icon={<TrashIcon />}
            />
          </Whisper>
        </CheckPermissions>
      </Cell>
    )
  }

  const Cell = Table.Cell

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Unique Code',
      dataKey: 'uniqueCode',
      flexGrow: 1,
      cell: <Cell dataKey='uniqueCode' />,
      sortable: true,
    },
    {
      label: 'Name',
      dataKey: 'name',
      flexGrow: 1,
      cell: <Cell dataKey='name' />,
      sortable: true,
    },
    {
      label: 'Email',
      dataKey: 'email',
      flexGrow: 1,
      cell: <Cell dataKey='email' />,
      sortable: false,
    },
    {
      label: 'Applied Date',
      dataKey: 'appliedDate',
      flexGrow: 1,
      cell: <Cell dataKey='appliedDate' />,
      sortable: false,
    },
    {
      label: 'Status',
      dataKey: 'statusName',
      flexGrow: 1,
      cell: <Cell dataKey='statusName' />,
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  useEffect(() => {
    dispatch(headHunt.actions.getHeadHuntApplications(params))
  }, [params])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Application deleted successfully')
    }

    if (exportSuccess) {
      toast.success('Application exported successfully')
    }
    handleChecked([])
    dispatch(headHunt?.actions.getHeadHuntApplications(params))
  }, [deleteSuccess, success, exportSuccess])

  const headHuntApplicationData = data?.headHuntApplicant
    ? data?.headHuntApplicant?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        id: item.id,
        jobCode: item.jobCode,
        slug: item.slug,
        name: item.name,
        uniqueCode: item.uniqueCode,
        appliedDate: item.appliedDate,
        email: item.email,
        status: item.status,
        statusName: item.headHuntApplicantStatus?.name,
        headHuntApplicantStatus: item.headHuntApplicantStatus,
      }))
    : []

  const handleExport = () => {
    // /apply-headhunt/export streams the CSV directly - no redux round-trip needed,
    // matching how generalApplication's real (working) export button behaves.
    headHuntService
      .exportHeadHuntApplications({fromDate: params.fromDate, toDate: params.toDate})
      .then((response: any) => {
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'head-hunt-applicant-list.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch((err: any) => toast.error(err.message))
  }

  const handleDelete = () => {
    let ids = checkedValues?.map((value) => ({id: value}))
    dispatch(headHunt?.actions?.deleteHeadHuntApplications(ids))
    handleAlertClose()
  }

  const handleRefresh = () => {
    dispatch(headHunt?.actions.getHeadHuntApplications(params))
  }

  const handleDownloadResume = () => {
    let applicantIds = ''
    if (checkedValues.length > 0) {
      for (let e in checkedValues) {
        //creating comma seperated Ids
        applicantIds = applicantIds ? applicantIds + ',' + checkedValues[e] : checkedValues[e]
      }
    }

    !isEmpty(checkedValues)
      ? axios
          .get(API_URL + `/apply-headhunt/get-resume?headHuntApplicantId=${applicantIds}`, {
            responseType: 'blob',
          })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'head-hunt-documents.zip')
            document.body.appendChild(link)
            link.click()
            handleChecked([])
          })
          .catch((err) => toast.error(err.message))
      : toast.error('No data selected')
  }

  return (
    <>
      <div className='shadow p-3 bg-white rounded' data-cy='head-hunt-shadow-comp'>
        <DesignComponent
          moduleName='Talent Head Hunt'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAlertOpen={handleAlertOpen}
          handleExport={handleExport}
          addShow={false}
          importShow={false}
          toggleMultipleShow={false}
          deleteShow={false}
          filterData={true}
          downloadResumeShow
          handleDownloadResume={handleDownloadResume}
          data-cy='head-hunt-design-comp'
        />

        <div className='d-flex align-items-center mb-3' style={{maxWidth: 260}}>
          <label className='me-2 mb-0'>Status</label>
          <SelectPicker
            data={statusOptions}
            searchable={false}
            cleanable
            placeholder='All'
            value={params.statusId}
            onChange={(value: string | null) => setParams({...params, page: 1, statusId: value || undefined})}
            data-cy='head-hunt-status-filter'
          />
        </div>

        <div className='datatable' data-cy='head-hunt-datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={headHuntApplicationData}
            checkedValues={checkedValues}
            showLoading={loading}
            data-cy='head-hunt-r-suite'
          />

          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
            data-cy='head-hunt-pagination'
          />

          {showViewCandidateDetailsModal &&
            applicationDetail?.headHuntApplicant?.[0] &&
            (() => {
              const candidate = applicationDetail.headHuntApplicant[0]
              return (
                <ViewCandidateDetails
                  handleClose={handleCloseViewDetails}
                  data={candidate}
                  provinceList={provinceData}
                  districtList={districtData}
                  zoneList={zoneData}
                  functionalAreaList={functionalAreaData}
                  municipalityList={municipalityData}
                  departmentList={departmentData}
                  branchList={branchData}
                  onShortlist={() => {
                    handleShortlist(candidate.id)
                    handleCloseViewDetails()
                  }}
                  onReject={() => {
                    handleReject(candidate.id)
                    handleCloseViewDetails()
                  }}
                />
              )
            })()}

          <>
            {alertOpen &&
              (!isEmpty(checkedValues) ? (
                <DeleteModal
                  handleClick={() => handleDelete()}
                  isOpen={alertOpen}
                  handleClose={() => handleAlertClose()}
                />
              ) : (
                toast.error('No data selected') && setAlertOpen(false)
              ))}
          </>
        </div>
      </div>
    </>
  )
}

export default HeadHunt
